import * as React from "react";
import InfoBanner from "../../common/components/InfoBanner";

type Props = {
    actionLink?: {
        disabled?: boolean;
        label: React.ReactNode;
        onClick: () => void;
    };
    containerClassName?: string;
    description?: React.ReactNode;
    isSystemDefault?: boolean;
    title?: React.ReactNode;
};

const systemDefaultDescription = (
    <>
        This workflow is used by the system-managed General task type. Statuses
        and transitions are already configured.
        <br />
        To use a different workflow, create a custom task type and configure its
        statuses.
    </>
);

const customTypeDescription = (
    <>
        Statuses and transitions are already configured. Customize the workflow
        to edit it.
    </>
);

const StandardWorkflowNotice: React.FC<Props> = ({
    actionLink,
    containerClassName,
    description,
    isSystemDefault = false,
    title = "Standard workflow",
}) => (
    <InfoBanner
        actionLink={actionLink}
        containerClassName={containerClassName}
        description={
            description ??
            (isSystemDefault ? systemDefaultDescription : customTypeDescription)
        }
        title={title}
    />
);

export default StandardWorkflowNotice;
